import axios from 'axios';
import { IChemicalElement } from '../../../../@types/model/masterData/chemicals/chemicalElement/chemicalElement';
import { IChemicalElementUpsert } from '../../../../@types/model/masterData/chemicals/chemicalElement/chemicalElementUpsert';
import { UpsertTypeEnum } from '../../../../@types/enum/upsertType';

export default class ChemicalElementHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IChemicalElement>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/ChemicalElement/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IChemicalElementUpsert, type : UpsertTypeEnum) : Promise<IChemicalElement> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/ChemicalElement/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/ChemicalElement/Delete`, {
            params: { id },
        });
    }
}